module.exports = __webpack_public_path__ + "img/文字_B级赛事@3x.d8cb9a0a.png";